// extracted by mini-css-extract-plugin
module.exports = {"side-navbar":"sideNavbar_side-navbar__1f_In","active":"sideNavbar_active__19yhS","home-icon":"sideNavbar_home-icon__emhcK","explore-icon":"sideNavbar_explore-icon__2jjDe"};